// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"185":"8c68404e","424":"23d6513e","528":"17395c71"}[chunkId] + ".chunk.css";
};